<template>
  <h1>Hello World</h1>
</template>

<script>
export default {
  name: "Questions",
};
</script>

<style></style>
